import React, { useContext, useEffect, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import SearchEventContext from '../context/SearchEventContext';
import { getTranslationByKey } from '../helpers/translation-helper';
import useElementPosition from '../hooks/useElementPosition';
import { DWTCContext } from '../utils/context';
import {
  Select,
  Arrow,
  Wrapper,
  BackgroundClick,
  Container,
  Option,
  Label,
} from './styles/SearchEventFormSelect.styled';

export default function SearchEventFormSelect({ options, fullWidth, option, setOption, dir }) {
  const { translations } = useContext(DWTCContext);
  const { displayMenu, displayFormInputs, clear } = useContext(SearchEventContext);
  const [toggle, setToggle] = useState(false);

  const [position, ref] = useElementPosition();

  useEffect(() => setOption(options[0]), []);
  useEffect(() => setOption(options[0]), [clear]);

  const handleOptionClick = (value) => {
    setOption(value);
    setTimeout(() => setToggle(false), 200);
  };

  return (
    <Wrapper width={fullWidth} clicked={displayMenu && displayFormInputs}>
      <BackgroundClick displayMenu={displayMenu} toggle={toggle} onClick={() => setToggle(false)} />
      <Select ref={ref} onClick={() => setToggle(!toggle)}>
        <Label dir={dir}>{getTranslationByKey(translations, option)}</Label>
        <Arrow dir={dir}>
          <IoIosArrowDown />
        </Arrow>
      </Select>
      <Container displayMenu={displayMenu} toggle={toggle} topOverflow={position.top < 404}>
        {options.map((value) => (
          <Option
            onClick={() => handleOptionClick(value)}
            key={value}
            selected={value === option}
            dir={dir}
          >
            {getTranslationByKey(translations, value)}
          </Option>
        ))}
      </Container>
    </Wrapper>
  );
}
